import { useState, useContext, useMemo } from "react"
import { Dropdown } from "primereact/dropdown"

import { UserContext } from "../../../../context/userContext"
import { useNavigate } from "react-router-dom"

import _ from "lodash"

export default function SelectEnterprise(props) {
  const [loading, setLoading] = useState(false)
  const userCtx = useContext(UserContext)
  const navigate = useNavigate()

  const enterprises = useMemo(
    () =>
      _.chain(props.enterpriseList)
        .filter((item) => !_.isEmpty(item.enterprise_name))
        .orderBy(["enterprise_name"], ["asc"])
        .value(),
    [props.enterpriseList]
  )

  if (enterprises.length <= 1) return null

  return (
    <div
      className="dropdown-title-container"
      style={{ marginLeft: 8, display: "flex", flexDirection: "column" }}
    >
      <span className="title-dropdown" style={{ fontSize: "11px" }}>
        Enterprise:
      </span>
      <Dropdown
        disabled={loading || props.fetching}
        value={userCtx.session.user.enterprise_id}
        options={enterprises}
        onChange={async ({ value }) => {
          await userCtx.changeEnterprise(value)
          navigate("/")
        }}
        optionLabel="enterprise_name"
        optionValue="enterprise_id"
        placeholder="Enterprises"
        filter={enterprises.length >= 5}
        style={{ marginBottom: 15 }}
      />
    </div>
  )
}
